/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit } from '@angular/core';
import { Participant } from '../../shared/model/Participant';
import { CommonService } from 'app/shared/services/common.service';

@Component({
  selector: 'demo-comp',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
  providers: []
})
export class DemoComponent {
  public memberObj: Participant = new Participant();
  public membersList: Participant[] = [];
  constructor(private commonService: CommonService) {}

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  ngOnInit() {}
}
